export const init = () => {
    const cards = document.querySelectorAll('.js-cards');
    if (cards.length === 0) return;
  
    cards.forEach(card => {
      const headings = card.querySelectorAll('.js-card-title');
      if (headings.length === 0) return;
  
      let maxHeadingHeight = 0;
      headings.forEach(heading => {
        maxHeadingHeight = Math.max(maxHeadingHeight, heading.clientHeight);
      });
  
      headings.forEach(heading => {
        heading.style.height = `${maxHeadingHeight}px`;
      });
    });
  };